import script from "./UserProjectTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProjectTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__